import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Building2, LayoutDashboard, FolderKanban, Image, HelpCircle, LogOut, ExternalLink, MapPinned, Layers3, FileText, Mail, ShieldCheck, Search, UserCircle2, Users } from "lucide-react";
import GlobalStatusBanner from "../components/GlobalStatusBanner";
import PageErrorBoundary from "../components/PageErrorBoundary";

const NAV = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/investments", "Investiții", FolderKanban],
  ["/admin/categories", "Domenii", Layers3],
  ["/admin/neighborhoods", "Cartiere", MapPinned],
  ["/admin/media", "Media", Image],
  ["/admin/pages", "Pagini", FileText],
  ["/admin/faqs", "FAQ", HelpCircle],
  ["/admin/profile", "Profil", UserCircle2],
  ["/admin/users", "Utilizatori", Users],
  ["/admin/frontend-seo", "SEO frontend", Search],
  ["/admin/cookie-consent", "Cookie banner", ShieldCheck],
  ["/admin/newsletter", "Newsletter", Mail],
];

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const loc = useLocation();

  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Se verifică sesiunea...</div>;
  if (!user) return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;

  return (
    <div className="min-h-screen flex bg-slate-50" data-testid="admin-layout">
      <aside className="w-64 bg-slate-900 text-slate-200 flex flex-col">
        <div className="px-5 py-5 border-b border-slate-800 flex items-center gap-2.5">
          <div className="w-9 h-9 bg-white text-slate-900 flex items-center justify-center rounded-sm">
            <Building2 size={20} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-bold text-white text-sm">Modernizăm Bacăul</div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-slate-400">Admin</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(([to, label, Icon, end]) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-sm text-sm font-medium transition-colors ${isActive ? "bg-sky-700 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"}`
              }
              data-testid={`admin-nav-${to.split("/").pop() || "dashboard"}`}
            >
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800 space-y-1">
          <Link to="/" className="flex items-center gap-3 px-3 py-2 rounded-sm text-sm text-slate-300 hover:bg-slate-800" data-testid="admin-view-site">
            <ExternalLink size={14} /> Vezi site-ul
          </Link>
          <button onClick={logout} className="w-full flex items-center gap-3 px-3 py-2 rounded-sm text-sm text-slate-300 hover:bg-slate-800" data-testid="admin-logout">
            <LogOut size={14} /> Ieșire
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col min-w-0">
        <header className="bg-white border-b border-slate-200 px-8 py-4 flex items-center justify-between">
          <div className="text-sm text-slate-500">Autentificat ca <span className="font-medium text-slate-900">{user.email}</span></div>
          <span className="text-[10px] uppercase tracking-[0.18em] bg-slate-100 text-slate-700 px-2 py-1 rounded-sm font-bold">{user.role}</span>
        </header>
        <GlobalStatusBanner />
        <main className="flex-1 p-8 overflow-visible">
          <PageErrorBoundary>
            <Outlet />
          </PageErrorBoundary>
        </main>
      </div>
    </div>
  );
}
